export default function PrivacyPage() {
  return (
    <main className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
      <h1 className="font-display text-4xl font-bold text-gray-900 mb-4">Privacy Policy</h1>
      <div className="w-16 h-1 bg-brand-400 rounded-full mb-4" />
      <p className="text-sm text-gray-400 mb-10">Last updated: {new Date().toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" })}</p>

      <div className="space-y-8 text-gray-600 leading-relaxed">
        <section>
          <h2 className="font-semibold text-gray-900 text-xl mb-3">1. Information We Collect</h2>
          <p>
            We collect information you provide directly to us. This includes:
          </p>
          <ul className="list-disc pl-5 mt-2 space-y-1.5">
            <li><strong>Account Information:</strong> Name, email address, and password.</li>
            <li><strong>Order Information:</strong> Shipping address, billing address, and payment method details (processed by third parties).</li>
            <li><strong>Communications:</strong> Any information you provide when contacting us.</li>
            <li><strong>Usage Data:</strong> Information about your interactions with our website, collected via cookies and similar technologies.</li>
          </ul>
        </section>

        <section>
          <h2 className="font-semibold text-gray-900 text-xl mb-3">2. Legal Basis for Processing</h2>
          <p>Under the General Data Protection Regulation (GDPR), we process your personal data based on the following legal grounds:</p>
          <ul className="list-disc pl-5 mt-2 space-y-1.5">
            <li><strong>Performance of a Contract:</strong> To process and fulfill your orders.</li>
            <li><strong>Consent:</strong> When you opt-in to receive marketing emails or accept non-essential cookies.</li>
            <li><strong>Legitimate Interests:</strong> To improve our services, ensure website security, and understand how our site is used.</li>
            <li><strong>Legal Obligation:</strong> To comply with tax, accounting, and other regulatory requirements.</li>
          </ul>
        </section>

        <section>
          <h2 className="font-semibold text-gray-900 text-xl mb-3">3. How We Use Your Information</h2>
          <ul className="list-disc pl-5 space-y-1.5">
            <li>Process and fulfill your orders</li>
            <li>Send order confirmations and shipping updates</li>
            <li>Respond to customer service requests</li>
            <li>Improve our website and product offerings</li>
            <li>Send marketing communications (only with your explicit consent)</li>
            <li>Comply with legal obligations</li>
          </ul>
        </section>

        <section>
          <h2 className="font-semibold text-gray-900 text-xl mb-3">4. Data Retention</h2>
          <p>
            We retain your personal data only for as long as necessary to fulfill the purposes for which it was collected, including for the purposes of satisfying any legal, accounting, or reporting requirements.
          </p>
          <ul className="list-disc pl-5 mt-2 space-y-1.5">
            <li><strong>Account Data:</strong> Retained as long as your account is active.</li>
            <li><strong>Order Data:</strong> Retained for a minimum of 7 years to comply with tax and accounting laws.</li>
            <li><strong>Marketing Data:</strong> Retained until you withdraw your consent or request erasure.</li>
          </ul>
        </section>

        <section>
          <h2 className="font-semibold text-gray-900 text-xl mb-3">5. Payment Processing</h2>
          <p>
            Payment information is processed securely by Stripe or PayPal. We do not store
            full credit card numbers on our servers. Stripe and PayPal are PCI-compliant payment
            processors and handle all sensitive financial data.
          </p>
        </section>

        <section>
          <h2 className="font-semibold text-gray-900 text-xl mb-3">6. Cookies</h2>
          <p>
            We use cookies to maintain your session, remember your cart contents, and analyze site traffic. You can manage your cookie preferences through our cookie consent banner or your browser settings.
          </p>
        </section>

        <section>
          <h2 className="font-semibold text-gray-900 text-xl mb-3">7. Your Rights</h2>
          <p>Under GDPR, you have the following rights regarding your personal data:</p>
          <ul className="list-disc pl-5 mt-2 space-y-1.5">
            <li><strong>Right of Access:</strong> You can request a copy of the data we hold about you.</li>
            <li><strong>Right to Rectification:</strong> You can request that we correct inaccurate or incomplete data.</li>
            <li><strong>Right to Erasure ("Right to be Forgotten"):</strong> You can request that we delete your data, subject to legal retention requirements.</li>
            <li><strong>Right to Data Portability:</strong> You can request to receive your data in a structured, commonly used format.</li>
            <li><strong>Right to Withdraw Consent:</strong> You can withdraw your consent for marketing at any time.</li>
            <li><strong>Right to Object:</strong> You can object to processing based on legitimate interests.</li>
          </ul>
          <p className="mt-4">
            You can exercise these rights directly through your <strong>Account</strong> page or by contacting us.
          </p>
        </section>

        <section>
          <h2 className="font-semibold text-gray-900 text-xl mb-3">8. Contact Us</h2>
          <p>
            If you have questions about this Privacy Policy or wish to exercise your rights, please contact us at{" "}
            <a href="mailto:hello@chlolodesigns.com" className="text-brand-600 hover:underline">
              hello@chlolodesigns.com
            </a>
            .
          </p>
        </section>
      </div>
    </main>
  );
}
